import { Action } from '../../../common/actions/core/action';

export class OpenStudentLimitAction implements Action {
  constructor() {}
}



// WEBPACK FOOTER //
// src/app/components/student/limit-exceeded/limit-exceeded.action.ts